<template>
  <div id="view-contact">
    <div id="contact-section-a" class="content-section reg">
      <div>
        <div>
          <PopupText text="Contact" tag="h1" :delay="0" v-mouse-parallax="20" />
        </div>
        <!-- <div>
          <div>
            <h2>Email</h2>
            <p>sales@littlearms.com</p>
          </div>
          <div>
            <h2>Address</h2>
            <p>Little Arms Studios</p>
            <p>7000 Infantry Ridge Rd</p>
            <p>Suite 103</p>
            <p>Manassas, VA 20109</p>
          </div>
        </div> -->
      </div>
    </div>
    <div id="contact-section-b" class="content-section">
      <div>
        <div>
          <div>
            <h2>Email</h2>
            <p>sales@littlearms.com</p>
          </div>
          <div>
            <h2>Address</h2>
            <p>Little Arms Studios</p>
            <p>7000 Infantry Ridge Rd</p>
            <p>Suite 103</p>
            <p>Manassas, VA 20109</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
@Component
class Contact extends Vue {}

export default Contact;
</script>

<style lang="scss" scoped>
#view-contact {
  // width: 100vw;
  // height: 100vh;
}

#contact-section-a {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 30vh;
  padding-top: 100px;
  background: linear-gradient(#daba05, #ffd47d);
  text-align: center;

  &::after {
    background: url(~@/assets/images/section-background.png);
    opacity: 0.9;
  }

  > div {
    // line-height: 0;

    > div {
      margin-bottom: 40px;

      &:nth-child(1) {
        //
      }

      &:nth-child(2) {
        color: #0095ff;
        padding: 20px;
        background: white;
        border-radius: 10px;
        box-shadow: 0 50px 50px -40px rgba(0, 0, 0, 0.25),
          0 0 60px 0 rgba(0, 0, 0, 0.1);

        > div {
          margin: 20px;

          p {
            margin: 0;
          }
        }
      }
    }
  }
}

#contact-section-b {
  background-image: url(~@/assets/images/test.png);

  > div {
    padding: 80px 20px;
    display: flex;
    max-width: 1000px;
    margin: 0 auto;
    justify-content: center;
    flex-wrap: wrap;
    flex-direction: column;

    > div {
      flex-basis: 30%;
      padding: 40px;
      // margin: 20px;
      max-width: 600px;
      margin: 0 auto 40px;
      background: white;
      border-radius: 10px;
      text-align: center;
      box-shadow: 0 50px 50px -40px rgba(0, 0, 0, 0.25),
        0 0 60px 0 rgba(0, 0, 0, 0.1);
      width: 100%;
      //
      color: #0095ff;
      padding: 40px;
      background: white;
      border-radius: 10px;
      box-shadow: 0 50px 50px -40px rgba(0, 0, 0, 0.25),
        0 0 60px 0 rgba(0, 0, 0, 0.1);
      box-sizing: border-box;

      > div {
        &:not(:last-child) {
          margin: 0 0 40px;
        }

        h2 {
          margin: 0 0 20px;
        }

        p {
          margin: 0;
          color: #545454;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Contact.vue